import React, { useState } from 'react';
import {
  Popover,
  IconButton,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box
} from '@mui/material';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import DeleteIcon from '@mui/icons-material/Delete';
import Upload from './Upload';

function ImageGalleryDropdown({ images, onUploadSuccess, onDelete, customerId, petId, serviceId, groomerId, userId, readOnly = false }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedImageId, setSelectedImageId] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteClick = (imageId) => {
    setSelectedImageId(imageId);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = () => {
    if (onDelete && selectedImageId) {
      onDelete(selectedImageId);
    }
    setDeleteDialogOpen(false);
    setSelectedImageId(null);
  };

  const cancelDelete = () => {
    setDeleteDialogOpen(false);
    setSelectedImageId(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'image-gallery-popover' : undefined;

  return (
    <div>
      <IconButton onClick={handleClick} aria-label="view images">
        <PhotoLibraryIcon
          sx={{
            fontSize: readOnly ? '18px' : '30px',
            color: images && images.length > 0 ? 'primary.main' : 'inherit'
          }}
        />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: { p: 2, maxWidth: 300, borderRadius: 2, boxShadow: 3 }
        }}
      >
        <Typography variant="h6" gutterBottom>Images</Typography>
        <Box sx={{ mb: 1 }}>
          <Grid container spacing={1}>
            {images && images.length > 0 ? (
              images.map((img, index) => (
                <Grid item key={img.id || index} xs={4}>
                  <a
                    href={img.imageUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={img.imageUrl}
                      alt={img.caption || "Image"}
                      style={{ width: '100%', borderRadius: 4 }}
                    />
                  </a>
                  {img.caption && (
                    <Typography variant="caption" display="block">
                      {img.caption}
                    </Typography>
                  )}
                  {!readOnly && (
                    <IconButton onClick={() => handleDeleteClick(img.id)} size="small">
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  )}
                </Grid>
              ))
            ) : (
              <Typography variant="body2">No images</Typography>
            )}
          </Grid>
        </Box>
        {!readOnly && (
          <Box>
            <Upload
              onUploadSuccess={onUploadSuccess}
              customerId={customerId}
              petId={petId}
              serviceId={serviceId}
              groomerId={groomerId}
              userId={userId}
            />
          </Box>
        )}
      </Popover>

      {/* Confirmation Dialog for deletion (only in non-readOnly mode) */}
      {!readOnly && (
        <Dialog open={deleteDialogOpen} onClose={cancelDelete}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this image?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={cancelDelete} color="primary">
              Cancel
            </Button>
            <Button onClick={confirmDelete} color="error">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}

export default ImageGalleryDropdown;